import { Collapser } from '@wearetla/tla-essentials-tools/partials/collapser';
import '/assets/styles/partials/collapser.scss'

export default Collapser;